import React from "react";
import CreatorDashboard from "@/pages/dashboard/CreatorDashboard";
const Creador = () => <CreatorDashboard />;
export default Creador;
